import { Component, inject } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { ILinkButtonTileDefinition } from '../../../dashboards/interfaces/tiles/definitions/link-button-tile.interface';
import { TileCreatorService } from '../../services/tile-creator.service';
import { TILE_REQUEST } from '../../tokens/tile-request.token';
import { TileSetupWizardComponent } from '../tile-setup-wizard.component';

@Component({
  standalone: false,
  selector: 'app-link-banner-setup-wizard',
  templateUrl: './link-banner-setup-wizard.component.html',
  styleUrls: ['./link-banner-setup-wizard.component.scss'],
})
export class LinkBannerSetupWizardComponent extends TileSetupWizardComponent<ILinkButtonTileDefinition> {

  dataSourceObject;

  get headingControl(): AbstractControl {
    return this.setupForm.get('heading') as AbstractControl;
  }

  get displayFeatureTotalControl(): AbstractControl {
    return this.setupForm.get('displayFeatureTotal') as AbstractControl;
  }

  get subHeadingControl(): AbstractControl {
    return this.setupForm.get('subHeading') as AbstractControl;
  }

  get headingIconControl(): AbstractControl {
    return this.setupForm.get('headingIcon') as AbstractControl;
  }

  get imgUriControl(): AbstractControl {
    return this.setupForm.get('imgUri') as AbstractControl;
  }

  get linkTextControl(): AbstractControl {
    return this.setupForm.get('linkText') as AbstractControl;
  }

  get routeLinkControl(): AbstractControl {
    return this.setupForm.get('routeLink') as AbstractControl;
  }

  constructor(
    private readonly fb: FormBuilder,
    private readonly tileCreatorService: TileCreatorService,
  ) {
    super();

    this.tileInstance = inject(TILE_REQUEST).tileInstance;
  }

  ngOnInit() {
    this.initSetupForms();

    this.hookForm();
  }

  initSetupForms() {
    this.setupForm = this.fb.group({
      heading: ['', Validators.required],
      subHeading: ['', Validators.required],
      displayFeatureTotal: ['', Validators.required],
      headingIcon: ['', Validators.required],
      imgUri: ['', Validators.required],
      linkText: ['', Validators.required],
      routeLink: ['', Validators.required],
    });

    if (this.tileInstance) {
      this.setupForm.patchValue(this.tileInstance);
    }
  }

  initDataSource(dataSource: any) {
    this.dataSourceObject = dataSource;
  }

  onCreate() {
    Object.assign(this.tileInstance, this.getChanges());
    this.tileCreatorService.onChange.next();
  }

  getChanges() {
    return {
      tileType: 'link-banner',
      heading: this.headingControl.value,
      headingIcon: this.headingIconControl.value,
      subHeading: this.subHeadingControl.value,
      imgUri: this.imgUriControl.value,
      linkText: this.linkTextControl.value,
      routeLink: this.routeLinkControl.value,
      displayFeatureTotal: this.displayFeatureTotalControl.value,
      canView: true,
    };
  }
}
